import * as React from 'react'
import type { CommonDeps } from '../base/CommonDeps'
import { renderCatch } from '../error/renderCatch'
import { type Unit, unitName, unitImage } from '../unit/unit'
import type { RenderCachedImage } from '../image/WithCachedImage'

interface Props {
    deps: CommonDeps
    units: Unit[]
    renderCachedImage: RenderCachedImage
}

export class UnitChips extends React.Component<Props, {}> {
    public render = () => renderCatch(this.props.deps, this.tryRender)

    private tryRender = () => {
        return (
            <div className="AppCore__unit__UnitChips">
                {this.props.units.map((unit) => (
                    <div className="AppCore__unit__UnitChips__unit" key={unit.id}>
                        <div className="AppCore__unit__UnitChips__image">
                            {this.props.renderCachedImage(
                                unitImage(unit),
                                null,
                                this.props.deps.getImage('missing-unit')
                            )}
                        </div>
                        <div className="AppCore__unit__UnitChips__name">{unitName(unit)}</div>
                    </div>
                ))}
            </div>
        )
    }
}
